import lightGrayButtonRule from '../../../light-gray/background/default/dark';

const dark = (params) => lightGrayButtonRule(params);

export default dark;
